/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Status_Passed_TitleInputs */

const en_course_status_passed_title = /** @type {(inputs: Course_Status_Passed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passed!`)
};

const ja_course_status_passed_title = /** @type {(inputs: Course_Status_Passed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格!`)
};

const fr_course_status_passed_title = /** @type {(inputs: Course_Status_Passed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussi !`)
};

const de_course_status_passed_title = /** @type {(inputs: Course_Status_Passed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestanden!`)
};

/**
* | output |
* | --- |
* | "Passed!" |
*
* @param {Course_Status_Passed_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_passed_title = /** @type {((inputs?: Course_Status_Passed_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Passed_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_passed_title(inputs)
	if (locale === "ja") return ja_course_status_passed_title(inputs)
	if (locale === "fr") return fr_course_status_passed_title(inputs)
	return de_course_status_passed_title(inputs)
});